module.exports = __webpack_public_path__ + "static/007817-0d7add15e645dd31b156bdcda0bee51a.jpg";